var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShowCoupon = function SvgShowCoupon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3481_32148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 5H3V19H1V5ZM4 5H6V19H4V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 10.25V6.75C23 5.7875 22.19 5 21.2 5H8.8C7.81 5 7.009 5.7875 7.009 6.75V10.25C7.999 10.25 8.8 11.0375 8.8 12C8.8 12.9625 7.999 13.75 7 13.75V17.25C7 18.2125 7.81 19 8.8 19H21.2C22.19 19 23 18.2125 23 17.25V13.75C22.01 13.75 21.2 12.9625 21.2 12C21.2 11.0375 22.01 10.25 23 10.25ZM21.2 8.9725C20.129 9.57625 19.4 10.7137 19.4 12C19.4 13.2863 20.129 14.4237 21.2 15.0275V17.25H8.8V15.0275C9.871 14.4237 10.6 13.2863 10.6 12C10.6 10.705 9.88 9.57625 8.809 8.9725L8.8 6.75H21.2V8.9725ZM12.363 15.5L15 13.855L17.637 15.5L16.836 12.56L19.257 10.635L16.134 10.4512L15 7.625L13.857 10.4425L10.734 10.6263L13.155 12.5512L12.363 15.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3481_32148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShowCoupon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "show-coupon.dce7ffc217ce235a5f32c1320c0d908c.svg";